export default{
  "Mute Video": "ビデオのミュート",
  "HitPaw Online Mute Video": "HitPawオンラインビデオミュート",
  "Fast and easy to remove sound from your video online": "オンライでンビデオから音声を素早く容易に削除",
  "Muting": "ミュート中",
  "Mute Failed": "ミュート失敗",
  "Mute New": "新たにミュート"
};